export const GET_APPOINTMENT_LINK = 'GET_APPOINTMENT_LINK';
export const GET_APPOINTMENT_LINK_SUCCESS = 'GET_APPOINTMENT_LINK_SUCCESS';
export const GET_APPOINTMENT_LINK_ERROR = 'GET_APPOINTMENT_LINK_ERROR';
export const MY_APPOINTMENTS_PAGE_LOADED_SUCCESS = 'MY_APPOINTMENTS_PAGE_LOADED_SUCCESS';
